import React, { useState, useEffect, useRef } from "react";
import Navbar from "../navbar";
import "../index.css";
import mainLogo from "../../../assets/png/tuataraLogo.png";
import NavButtons from "../navButtons";
import { NavLink, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../config/msalConfig";
import { jwtDecode } from "jwt-decode";
import { ApplicationId, vizybilityConfig } from "../../../api/url";
import { postGetVizyBilityToken } from "../../../services/getVizyBilityToken";
import NZNavbar from "./NZNavbar";
import NZNavButtons from "./NZNavButtons";
import { dealerPortalStyle } from "../../../common/dealerPortalStyle";
import RegionSwitcher from "../RegionSwitcher/RegionSwitcher";

export const NZHeader = () => {
  const topPartRef = useRef(null);
  const { instance, accounts } = useMsal();
  const [openWarning, setOpenWarning] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleOpenWarning = () => {
    setOpenWarning(true);
    localStorage.setItem("OpenWarning", true);
  };

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const idToken = await instance.loginPopup(loginRequest);
      handleRedirectCallback(idToken.accessToken);
    } catch (error) {
      console.error("Login error:", error);
      setIsLoading(false);
    }
  };

  const handleRedirectCallback = async (response) => {
    try {
      const decodedToken = jwtDecode(response);
      if (decodedToken?.extension_UserStatus) {
        // Stop loading after processing response
        if (decodedToken.extension_UserStatus === undefined || decodedToken.extension_UserStatus === "Pending") {
          await instance.logoutPopup({
            postLogoutRedirectUri: window.location.origin,
          });
          setIsLoading(false);
          handleOpenWarning();
          localStorage.removeItem("vizy-bility-token");
          localStorage.removeItem("client_info");
        } else if (decodedToken.extension_UserStatus === "Approved") {
          let payload = new URLSearchParams({
            grant_type: vizybilityConfig.grant_type,
            username: decodedToken.extension_GenericWebUsername,
            password: decodedToken.extension_GenericWebUserPassword,
            client_id: vizybilityConfig.STS_CLIENT_ID,
            client_secret: vizybilityConfig.STS_CLIENT_SECRET,
            scope: vizybilityConfig.STS_SCOPE,
            ApplicationId: ApplicationId,
          });
          setIsLoading(true);
          postGetVizyBilityToken({
            url: vizybilityConfig.STS_SIGNIN_URL,
            payload,
          })
            .then((res) => {
              if (res?.data?.access_token) {
                localStorage.setItem("vizy-bility-token", res.data.access_token);
                localStorage.setItem("client_info", JSON.stringify(decodedToken));
                window.scrollTo(0, 0);
                setIsLoading(false);
                navigate("/dealers-portal");
              }
            })
            .catch(async (err) => {
              setIsLoading(false);
              handleOpenWarning();
              await instance.logoutPopup({
                postLogoutRedirectUri: window.location.origin,
              });
              localStorage.removeItem("vizy-bility-token");
              localStorage.removeItem("client_info");
            });
        } else {
          await instance.logoutPopup({
            postLogoutRedirectUri: window.location.origin,
          });
          setIsLoading(false);
          handleOpenWarning();

          localStorage.removeItem("vizy-bility-token");
          localStorage.removeItem("client_info");
        }
      } else {
        handleOpenWarning();
        await instance.logoutPopup({
          postLogoutRedirectUri: window.location.origin,
        });
        localStorage.removeItem("vizy-bility-token");
        localStorage.removeItem("client_info");
      }
    } catch (error) {
      console.error("Error handling redirect callback:", error);
      setIsLoading(false); // Stop loading on error
    } finally {
    }
  };

  const handleCloseWarning = () => {
    setIsLoading(false);
    setOpenWarning(false);
    localStorage.removeItem("OpenWarning");
  };

  return (
    <header
      className={`sticky top-[70px] z-[21] transition-colors duration-300 bg-[#383838] py-[20px] h-[100px]`}
      ref={topPartRef}
    >
      {isLoading ? (
        <div className="absolute w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center">
          <span class="loader"></span>
        </div>
      ) : null}
      <div className=" max-w-[1440px] mx-auto flex items-center justify-between md:px-[3rem] px-[1rem]">
        {/* <div class="w-[1920px] h-[100px] mx-auto flex items-center justify-between md:px-[3rem] px-[1rem]"> */}
        <div className="flex">
          <div className="mr-[20px]">
            <img
              src={mainLogo}
              className="w-auto h-[40px] xl:h-[60px] lg:h-[60px] md:h-[50px] sm:h-[40px] cursor-pointer"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/");
              }}
            />
          </div>
          <NZNavbar
            openWarning={openWarning}
            setOpenWarning={setOpenWarning}
            handleLogin={handleLogin}
            handleCloseWarning={handleCloseWarning}
          />
        </div>
        <div
          key={1}
          to={"/"}
          className={dealerPortalStyle}
          onClick={() => {
            // const section = document.getElementById("contact-form");
            // const sectionTop = section.getBoundingClientRect().top + window.pageYOffset; // Section's top position relative to the viewport
            // const offset = topPartRef?.current?.offsetHeight || 300; // Adjust for the desired offset
            // window.scrollTo({
            //   top: sectionTop - offset,
            //   behavior: "smooth",
            // });
            navigate("/nz/ContactUs");
          }}
        >
          CONTACT US
        </div>
        <NZNavButtons
          openWarning={openWarning}
          setOpenWarning={setOpenWarning}
          handleLogin={handleLogin}
          handleCloseWarning={handleCloseWarning}
        />
      </div>
    </header>
  );
};
